export default "__VITE_ASSET__BOjorK9z__";